import cookies from "browser-cookies";
import queryString from "query-string";

("use strict");

export default class User {
    constructor(props) {
        if (props) {
            this.props = props;
        } else {
            this.props = {};
        }

        this.getPatientAndEncounterIdsFromHash = this.getPatientAndEncounterIdsFromHash.bind(this);
        this.fetchAssignments = this.fetchAssignments.bind(this);
        this.getAssignments = this.getAssignments.bind(this);

        this.onAssignmentsLoaded = this.props.onAssignmentsLoaded;
    }

    setHash(location, history, hash) {
        if (history.replaceState) {
            history.replaceState(
                null,
                null,
                location.pathname + location.search + (hash ? "#" + hash : "")
            );
        } else {
            location.hash = hash;
        }
    }

    setLoggedIn(loggedIn, passcode, daysToExpiry) {
        var options = { expires: daysToExpiry || 1, secure: true, samesite: "None" };

        if (loggedIn) {
            cookies.set("loggedIn", "1", options);
            if (passcode) cookies.set("passcode", passcode, options);
        } else {
            cookies.set("loggedIn", "0", options);
            cookies.erase("passcode");
        }
    }

    isLoggedIn() {
        return cookies.get("loggedIn") === "1";
    }

    getParamFromHash(location, history, param, remove) {
        var hash = queryString.parse(location.hash);

        if (hash[param]) {
            var value = hash[param];
            if (remove) {
                delete hash[param];
                this.setHash(location, history, queryString.stringify(hash));
            }
            return value;
        } else {
            return undefined;
        }
    }

    getPasscode() {
        return cookies.get("passcode");
    }

    getAndRemovePasscodeFromHash(location, history) {
        return this.getParamFromHash(location, history, "passcode", true);
    }

    getPatientId() {
        return cookies.get("patientId");
    }

    getEncounterId() {
        return cookies.get("encounterId");
    }

    getPatientAndEncounterIdsFromHash(location, history, remove) {
        var patientId = this.getParamFromHash(location, history, "patientId", true);
        if (patientId) {
            this.setPatientId(patientId, 365);
            this.setEncounterId(null);
        }

        var encounterId = this.getParamFromHash(location, history, "encounterId", remove);
        if (encounterId) this.setEncounterId(encounterId, 365);

        return encounterId;
    }

    getAssignmentIdFromHash(location, history) {
        return this.getParamFromHash(location, history, "assignmentId", false);
    }

    setPatientId(patientId, daysToExpiry) {
        cookies.set("patientId", patientId, {
            expires: daysToExpiry || 1,
            secure: true,
            samesite: "None",
        });
    }

    setEncounterId(encounterId, daysToExpiry) {
        if (encounterId)
            cookies.set("encounterId", encounterId, {
                expires: daysToExpiry || 1,
                secure: true,
                samesite: "None",
            });
        else cookies.erase("encounterId");
    }

    moveWelcomeBeforeRecommended(welcomeDiv, recommendedDiv) {
        var welcome = $("#" + welcomeDiv);
        if (!welcome.length) return;

        var recommended = $("#" + recommendedDiv);
        if (!recommended.length) return;

        recommended.parent().prepend(welcome.detach());
    }

    getAssignments(success, failure) {
        if (this.props.assignments) {
            if (success) success(this.props.assignments);
        } else this.fetchAssignments(success, failure);
    }

    scheduleFetchAssignments(timeoutMillis) {
        if (this.timeout) window.clearTimeout(this.timeout);

        this.timeout = window.setTimeout(this.fetchAssignments, timeoutMillis);
        this.timeoutMillis = timeoutMillis;
    }

    fetchAssignments(success, failure) {
        const url =
            this.props.assignmentsApiUrl +
            "/" +
            this.getEncounterId() +
            (this.props.assignmentsApiView ? "?View=" + this.props.assignmentsApiView : "");
        fetch(url, {
            cache: "no-store",
            headers: new Headers({
                Pragma: "no-cache",
            }),
        })
            .then((result) => {
                if (!result.ok) throw Error();

                result.json().then((result) => {
                    var patientId = result.patientId;
                    var assignments = result.assignments;
                    var notifications = 0;

                    if (patientId && patientId !== this.getPatientId())
                        this.setPatientId(patientId);

                    for (var a in assignments) {
                        var assignment = assignments[a];

                        var status = assignment.status;

                        var numIncompleteItems = 0;

                        assignment.displayAsComplete =
                            status === "actionRequired" ||
                            status === "readyToConfirm" ||
                            assignment.complete;
                        if (!assignment.displayAsComplete) notifications += 1;

                        var progress = 0;
                        for (var i in assignment.items) {
                            var item = assignment.items[i];

                            if (item.asset)
                                item.asset.urlWithHash =
                                    item.asset.url +
                                    "#encounterId=" +
                                    result.id +
                                    "&assignmentId=" +
                                    assignment.id;

                            progress += item.progress;

                            item.displayAsComplete = item.progress >= 1;

                            if (!item.displayAsComplete) {
                                numIncompleteItems += 1;

                                if (numIncompleteItems === 1) assignment.lastIncompleteItem = item;
                                else delete assignment.lastIncompleteItem;

                                if (!assignment.displayResumeItem)
                                    assignment.displayResumeItem = item;
                            }
                        }

                        assignment.displayProgress = progress / assignment.items.length;
                    }

                    for (a = 0; a < assignments.length; a++) {
                        assignment = assignments[a];

                        for (var b = 1; b < assignments.length; b++) {
                            var nextAssignment = assignments[(a + b) % assignments.length];
                            if (!nextAssignment.displayAsComplete) {
                                assignment.displayNextAssignment = nextAssignment;
                                break;
                            }
                        }
                    }

                    cookies.set("notifications", "" + notifications, {
                        secure: true,
                        samesite: "None",
                    });

                    this.props.assignments = result;

                    if (success) success(result);

                    if (this.onAssignmentsLoaded) this.onAssignmentsLoaded(result);

                    this.scheduleFetchAssignments(20000);
                });
            })
            .catch((error) => {
                this.scheduleFetchAssignments(20000);
                if (failure) failure();
            });
    }

    getReportingEndpoint(facilityId) {
        switch (facilityId) {
            case "97-05771":
            case "97-24998":
            case "97-24999":
            case "97-44053":
            case "97-44155":
                return this.props.reportingEndpoint;
            default:
                return null;
        }
    }

    reportAssignmentProgress(
        assetId,
        assignment,
        assignmentItem,
        segmentStart,
        segmentLength,
        totalLength
    ) {
        const body = JSON.stringify({
            siteId: this.props.facilityId,
            keyId: assetId,
            patientId: this.getPatientId(),
            hcoId: this.getEncounterId(),
            assignmentId: assignment ? assignment.id : null,
            assignmentItemId: assignmentItem ? assignmentItem.id : null,
            segmentStart: segmentStart,
            segmentLength: segmentLength,
            totalLength: totalLength,
        });
        const url = "/reporting/progress";
        fetch(url, {
            method: "POST",
            mode: "cors",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
            },
            body: body,
        }).then((result) => {
            if (this.getEncounterId()) this.scheduleFetchAssignments(1000);
        });
    }

    reportAssessmentResult(assignment, assignmentItem, assessment, answer) {
        let encounterId = this.getEncounterId();
        const body = JSON.stringify({
            wasCorrect: answer,
            assessment: assessment,
            assignmentId: assignment ? assignment.id : null,
            assignmentItemId: assignmentItem ? assignmentItem.id : null,
            hcoId: encounterId,
        });
        const url = `/reporting/assessment/answer`;
        fetch(url, {
            method: "POST",
            mode: "cors",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
            },
            body: body,
        }).then((result) => {
            this.scheduleFetchAssignments(100);
        });
    }

    triggerPathway(pathwayId, pathway) {
        const url = `/api/assignments/pathway/${pathwayId}`;
        const body = JSON.stringify({ ...pathway });
        fetch(url, {
            method: "PUT",
            mode: "cors",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
            },
            body: body,
        }).catch((error) => {
            console.error(error);
        });
    }

    getNotifications() {
        return parseInt(cookies.get("notifications") || "0");
    }
}
